import React from "react";
import Link from "../link";
import photoNotAvailable from "./images/photo-not-available.jpg";
import { Container, Slider, Image } from "./styled/listing-card-slider";

function ListingCardSlider(_a) {
  var url = _a.url,
      photos = _a.photos,
      isHidden = _a.isHidden,
      _b = _a.address,
      address = _b === void 0 ? "Listing" : _b,
      handleClick = _a.handleClick;
  var noImage = React.createElement(Image, {
    src: photoNotAvailable,
    alt: "No photo available for this property"
  });
  return React.createElement(Container, null, React.createElement(Slider, {
    isHidden: isHidden,
    key: JSON.stringify(photos)
  }, !photos.length && url && React.createElement(Link, {
    to: url
  }, noImage), !photos.length && !url && React.createElement("div", {
    onClick: handleClick
  }, noImage), photos.map(function (photo, index) {
    var image = React.createElement(Image, {
      src: photo,
      onError: function onError(e) {
        return e.target.src = photoNotAvailable;
      },
      alt: address + " Image Slider - Slide " + (index + 1)
    });

    if (url) {
      return React.createElement(Link, {
        key: index,
        to: url
      }, image);
    } else {
      return React.createElement("div", {
        key: index,
        onClick: handleClick
      }, image);
    }
  })));
}

export default ListingCardSlider;